<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="elevation-10">
          <v-toolbar :color="'primary white--text'">
            <v-spacer></v-spacer>
            <v-toolbar-title>
              Projeto de Pesquisa {{projetoPesquisa.numRegistro === null || projetoPesquisa.numRegistro === '' ? '' : 'nº ' + projetoPesquisa.numRegistro + ' '}} - {{projetoPesquisa.titulo}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tabs
              centered
              show-arrows
              dark
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              color="primary"
              hide-slider
              slot="extension">

              <!-- Aba "Informações Básicas" -->
              <router-link exact :to="{name: 'ProjetoPesquisaInformacoesBasicas'}" tag="v-tab">Informações Básicas</router-link>

              <!-- Aba "Detalhamento" -->
              <router-link :class="habilitaOutrasAbas()" exact :to="{name: 'ProjetoPesquisaDetalhamento'}" tag="v-tab">Detalhamento</router-link>

              <!-- Aba "Instituições" -->
              <router-link :class="habilitaOutrasAbas()" exact :to="{name: 'ProjetoPesquisaInstituicoes'}" tag="v-tab">Instituições</router-link>

              <!-- Aba "Equipe" -->
              <router-link :class="habilitaOutrasAbas()" exact :to="{name: 'ProjetoPesquisaEquipe'}" tag="v-tab">Equipe</router-link>

              <!-- Aba "Órgãos Financiadores" -->
              <router-link :class="habilitaOutrasAbas()" exact :to="{name: 'ProjetoPesquisaOrgaosFinanciadores'}" tag="v-tab">Órgãos Financiadores</router-link>

              <!-- Aba "Arquivos" -->
              <router-link :class="habilitaOutrasAbas()" exact :to="{name: 'ProjetoPesquisaArquivos'}" tag="v-tab">Arquivos</router-link>

              <!-- Aba "Outras Informações" -->
              <router-link :class="habilitaOutrasAbas()" exact :to="{name: 'ProjetoPesquisaOutrasInformacoes'}" tag="v-tab">Outras Informações</router-link>

              <!-- Aba "Contatos" -->
              <router-link :class="habilitaOutrasAbas()" exact :to="{name: 'ProjetoPesquisaContatos'}" tag="v-tab">Contatos</router-link>

              <!-- Aba "Resultados Obtidos" -->
              <router-link v-if="habilitaAbaResultadosObtidos()" exact :to="{name: 'ProjetoPesquisaResultadosObtidos'}" tag="v-tab">Resultados Obtidos</router-link>

            </v-tabs>
          </v-toolbar>
          <v-card-text>
            <router-view :idProjetoPesquisa="idProjetoPesquisa" :projetoPesquisa="this.projetoPesquisa"></router-view>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <br>

    <!-- Barra do administrador -->
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="elevation-10">
          <c-barra-administrador-prppg :projeto="this.projetoPesquisa"></c-barra-administrador-prppg>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import projetos from '@/utils/projetos'
import BarraAdministrador from '@/components/c-barra-administrador-prppg'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa'],
  data: () => ({
    projetoPesquisa: {}
  }),
  computed: {
    ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'administradorPRPPG', 'permissaoCriarProjetoExtensao'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),

    // Verifica se o projeto de pesquisa está na situação "Em andamento".
    situacaoEmAndamento: function () {
      if (this.projetoPesquisa.situacao.item === 3) {
        return true
      } else {
        return false
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Concluído".
    situacaoConcluido: function () {
      if (this.projetoPesquisa.situacao.item === 4) {
        return true
      } else {
        return false
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function () {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true
      } else {
        return false
      }
    },

    // Habilita aba "Resultados Obtidos".
    habilitaAbaResultadosObtidos: function () {
      if (this.situacaoEmAndamento() || this.situacaoConcluido()) {
        return true
      } else {
        return false
      }
    },

    // Habilita abas exceto "Informações Básicas" e "Resultados Obtidos".
    habilitaOutrasAbas: function () {
      if (this.situacaoCancelado() === true && this.administradorPRPPG !== true && this.projetoPesquisa.coordenador !== true) {
        return 'router_disable'
      } else {
        return ''
      }
    }

  },
  mounted () {
    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
    projetos.getProjetoPesquisa(this.idProjetoPesquisa)
    .then(response => {
      this.projetoPesquisa = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-barra-administrador-prppg': BarraAdministrador
  }
}
</script>

<style lang="css" scoped>
  .v-tab {
    margin-left: 0.5em;
    border-top-right-radius: 1em !important;
    border-top-left-radius: 1em !important;
    transform: perspective(25px) rotateX(2deg) !important;
    transform-origin: bottom !important;
    max-width: 12em !important;
    min-width: 4em !important;
  }
  .v-tab--active {
    color: black !important;
    background-color: white;
  }
  .v-tab:not(.router-link-active) {
    color: white !important;
    background-color: rgba(0, 0, 0, 0.33);
  }
  .v-tab.router-link-active {
    color: black !important;
    background-color: white !important;
  }
  .v-tab >>> .tabs__container {
    transition: -webkit-transform .3s cubic-bezier(.86,0,.07,1);
    transition: transform .3s cubic-bezier(.86,0,.07,1);
  }

  .router_disable {
    color: #dddddd !important;
    background-color: #848484 !important;
    pointer-events: none;
  }

  .titulo {
    color: black;
    text-align: justify;
    font-size: 14pt;
  }
</style>



// WEBPACK FOOTER //
// projeto-pesquisa.vue?4c98f7c8